import { render, staticRenderFns } from "./housekeepingResourceManage.vue?vue&type=template&id=3f297ae4&scoped=true"
import script from "./housekeepingResourceManage.vue?vue&type=script&lang=js"
export * from "./housekeepingResourceManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingResourceManage.vue?vue&type=style&index=0&id=3f297ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f297ae4",
  null
  
)

export default component.exports